import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import { BrowserRouter } from "react-router-dom";

// Lazy load AuthProvider to defer Firebase loading
const AuthProvider = lazy(() =>
  import("./context/AuthProvider").then((module) => ({
    default: module.AuthProvider,
  }))
);

// Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", {
        scope: "/",
      });

      // Store registration globally for use in components
      window.swRegistration = registration;

      console.log("SW registered: ", registration);

      // Handle updates
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New service worker available
              console.log("New service worker available");
            }
          });
        }
      });
    } catch (error) {
      console.log("SW registration failed: ", error);
    }
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<div className="app-loading-fallback">Loading...</div>}>
      <BrowserRouter>
        <Suspense
          fallback={<div className="app-loading-fallback">Loading auth...</div>}
        >
          <AuthProvider>
            <App />
          </AuthProvider>
        </Suspense>
      </BrowserRouter>
    </Suspense>
  </StrictMode>
);
